"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: STACKS_API_VERSION
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RosettaSubAccountToJSON = exports.RosettaSubAccountFromJSONTyped = exports.RosettaSubAccountFromJSON = void 0;
const runtime_1 = require("../runtime");
function RosettaSubAccountFromJSON(json) {
    return RosettaSubAccountFromJSONTyped(json, false);
}
exports.RosettaSubAccountFromJSON = RosettaSubAccountFromJSON;
function RosettaSubAccountFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'address': json['address'],
        'metadata': !runtime_1.exists(json, 'metadata') ? undefined : json['metadata'],
    };
}
exports.RosettaSubAccountFromJSONTyped = RosettaSubAccountFromJSONTyped;
function RosettaSubAccountToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'address': value.address,
        'metadata': value.metadata,
    };
}
exports.RosettaSubAccountToJSON = RosettaSubAccountToJSON;
//# sourceMappingURL=RosettaSubAccount.js.map